export default function Footer() {
  return (
    <footer className="border-t border-stone bg-bone mt-24">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-12 py-12 grid grid-cols-1 md:grid-cols-4 gap-8 text-sm">
        <div>
          <div className="font-serif text-2xl text-ink mb-2">Carolina Peer Institute</div>
          <p className="text-muted-foreground leading-relaxed">
            A clinical-grade training program for North Carolina's Certified Peer Support Specialists,
            aligned to the 40-hour NCCPSS standard.
          </p>
        </div>
        <div>
          <div className="label-eyebrow mb-3">Program</div>
          <ul className="space-y-2 text-muted-foreground">
            <li>40 instructional hours</li>
            <li>12 clinical modules</li>
            <li>Mastery quizzes, 80% passing</li>
            <li>Certificate of completion</li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-3">Partner</div>
          <ul className="space-y-2 text-muted-foreground">
            <li><a href="/generational-health" className="hover:text-ink transition-colors">Generational Health</a></li>
            <li><a href="https://generationalh.com" target="_blank" rel="noopener noreferrer" className="hover:text-ink transition-colors">generationalh.com ↗</a></li>
            <li>Employment for graduates</li>
            <li>Your mind. Your power.</li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-3">References</div>
          <ul className="space-y-2 text-muted-foreground">
            <li>NC DHHS · 10A NCAC 27G</li>
            <li>UNC Behavioral Health Springboard</li>
            <li>SAMHSA Recovery Principles</li>
            <li>988 Suicide &amp; Crisis Lifeline</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-stone py-4 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Carolina Peer Institute · A clinical training platform
      </div>
    </footer>
  );
}
